// StartPage.jsx
import { Canvas } from "@react-three/fiber";
import { OrbitControls, Float, Stars } from "@react-three/drei";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function StartPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Enter") {
        navigate("./Tc2");
      }
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [navigate]);

  return (
    <div style={{ width: "100vw", height: "100vh", overflow: "hidden" }}>
      {/* 3D CANVAS BACKGROUND */}
      <Canvas camera={{ position: [0, 2, 6], fov: 50 }}>
        <ambientLight intensity={2} />
        <directionalLight intensity={3} position={[5, 5, 5]} />

        <Stars radius={200} depth={50} count={5000} factor={4} fade />

        <Float speed={2} floatIntensity={2}>
          <mesh scale={1.5}>
            <torusKnotGeometry args={[1, 0.3, 300, 20]} />
            <meshStandardMaterial color="#ff00ff" emissive="#440044" emissiveIntensity={1} />
          </mesh>
        </Float>

        <OrbitControls enableZoom={false} />
      </Canvas>

      {/* OVERLAY UI */}
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: "rgba(0,0,0,0.4)",
          color: "white",
          textAlign: "center",
          pointerEvents: "none",
        }}
      >
        <h1
          style={{
            fontSize: "5rem",
            fontWeight: "800",
            textShadow: "0px 0px 50px #ff00ff",
          }}
        >
          CODE QUEST
        </h1>

        <p
          style={{
            fontSize: "2rem",
            marginTop: "20px",
            animation: "blink 1.5s infinite",
          }}
        >
          PRESS ENTER TO BEGIN
        </p>

        <style>
          {`
            @keyframes blink {
              0% { opacity: 1; }
              50% { opacity: 0.3; }
              100% { opacity: 1; }
            }
          `}
        </style>
      </div>
    </div>
  );
}
